export const festivalData = [
  {
    name: "Diwali",
    date: "11-14",
    image: "/posters/diwali.jpg",
    message: "Happy Diwali! May your home shine with light ✨"
  },
  {
    name: "Pongal",
    date: "01-15",
    image: "/posters/pongal.jpg",
    message: "Happy Pongal! Wishing you prosperity 🌾"
  },
  {
    name: "New Year",
    date: "01-01",
    image: "/posters/newyear.png",
    message: "Happy New Year! 🎉✨"
  }
];
